<div class="row">
    <div class="col-lg-12">
        <div class="card" id="contactList">
            <div class="card-header">
                <div class="d-flex align-items center">
                    <h5 class="card-title mb-0 flex-grow-1">{{'Vibration Dashboard' | translate}}</h5>
                </div>
            </div>
            <div class="card-body">
                <!-- Dropdown for Device IDs -->
                <div class="row">
                    <div class="col-lg-6">
                        <label for="deviceDropdown">{{"Select Device" | translate}}:</label>
                        <select id="deviceDropdown" class="form-control" (change)="onDeviceChange($any($event.target).value)">
                            <option value="">{{"Select a Device" | translate}}</option>
                            @for (device of devices; track device.uid) {
                            <option [value]="device.uid">
                                {{ device.device_name }}
                            </option>
                            }
                        </select>
                    </div>

                    <!-- Dropdown for Operations -->
                    <div class="col-lg-6">
                        <label for="operationDropdown">{{"Select Operation" | translate}}:</label>
                        <select id="operationDropdown" class="form-control" (change)="onOperationChange($any($event.target).value)">
                            @if (operations.length > 0) {
                                <option value="">{{"Select an operation" | translate}}</option>
                                @for (operation of operations; track operation.opp_id) {
                                  <option [value]="operation.opp_id">
                                    {{ operation.opp_id }} ({{ operation.cr_time | date: 'dd.MM.yyyy HH:mm' }})
                                  </option>
                                }
                              } @else {
                                <option value="" disabled>{{"No operation found" | translate}}</option>
                              }
                        </select>
                    </div>
                </div>

                <!-- Display Graph Data -->
                <div class="row mt-5">
                    <div class="col-lg-12">
                        <canvas baseChart
                            [datasets]="chartDatasets"
                            [labels]="graphData.yData"
                            [options]="chartOptions"
                            [legend]="true"
                            [type]="'line'">
                    </canvas>
                       
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>